export class FeatureFlags {
    static readonly ASSIGN_PROPERTY_ROLE_FROM_IDENTIFY_ASSETS = 'model-editor-point-role';
    static readonly ASSIGN_LOCATION_FROM_IDENTIFY_ASSETS = 'model-editor-assign-location';
    static readonly HISTORY_VALIDATION = 'history-validation';
    static readonly PUBLISH_HISTORY_DATA = 'publish-history-data';
    static readonly AUTOMATIC_ANALYTICS_SETUP = 'automatic-analytics-setup';
    static readonly PUBLISH_ASSET_MODEL = 'publish-asset-model';
    static readonly IMPROVED_CONTEXT_DISCOVERY_ACCURACY = 'improved-context-discovery-accuracy';
    static readonly UNIFIED_WORKFLOW = 'unified-onboarding-workflow';
    static readonly COR_TOOL_ACCESS = 'cor-tool-access';
    static readonly GATEWAY_CONFIG = 'intelligent-gateway';
    static readonly EVENT_LOGGING = 'onboarding-event-log';
    static readonly CDT_LANGUAGE_CONFIGURATION = 'cdt-language-configuration';
    static readonly GATEWAY_TENANT = 'tenant-gateway';
}
